@if (formGroup) {
  <form id="mainForm" [formGroup]="formGroup">
    <smart-select height="30px" width="320px" id="newattribute-select" style="font-size: 25px;"  [items]="attributes" [formControl]="newattribute"  bindLabel="name"  bindValue="id" [bindDisabled]="isAttributeInTemplate" (selectionChange)="onAddattribute()" ></smart-select>
    <table class="mat-elevation-z2" style="width: 100%;">
      <tr>
        <th class="mdc-data-table__header-cell">Séq.</th>
        <th class="mdc-data-table__header-cell">Attribut</th>
        <th class="mdc-data-table__header-cell">Nom court</th>
        <th>&nbsp;</th>
        <th>&nbsp;</th>
        <th>&nbsp;</th>
      </tr>
      @for (t of tplAttributes; track t; let i = $index) {
        <tr class="form-row" [formGroup]="t">
          <!-- <td>{{t.value | json}}</td> -->
          <td >{{t.get("seq")?.value}}</td>
          <td >{{t.get("name")?.value}}</td>
          <td >{{t.get("shortname")?.value}}</td>
          <!-- <td><button mat-icon-button color="primary" *ngIf="i < tplAttributes.length-1" (click)="moveLine(t.get('id')?.value, t.get('seq')?.value, +1)"><mat-icon>arrow_drop_down</mat-icon></button></td> -->
          <td>@if (i < tplAttributes.length-1) {
            <button class="custom-icon-button primary" (click)="moveLine($safeNavigationMigration(t.get('id')?.value), $safeNavigationMigration(t.get('seq')?.value), +1)"><mat-icon style="transform: scale(1.7);">arrow_drop_down</mat-icon></button>
          }</td>
          <!-- <td><button mat-icon-button color="primary" *ngIf="i>0" (click)="moveLine(t.get('id')?.value, t.get('seq')?.value, -1)"><mat-icon>arrow_drop_up</mat-icon></button></td> -->
          <td>@if (i>0) {
            <button class="custom-icon-button primary" (click)="moveLine($safeNavigationMigration(t.get('id')?.value), $safeNavigationMigration(t.get('seq')?.value), -1)"><mat-icon style="transform: scale(1.7);">arrow_drop_up</mat-icon></button>
          }</td>
          <!-- <td><button mat-icon-button color="primary" aria-label="Supprimer" style="padding: 0px; margin-left:6px; max-height: 20px; max-width: 20px;" (click)="deleteLine(t.get('id')?.value)"><mat-icon style="font-size: 16px; margin-top: -6px; max-height: 20px; max-width: 20px;">delete</mat-icon></button></td> -->
          <td><button class="custom-icon-button error" aria-label="Supprimer"  (click)="deleteLine($safeNavigationMigration(t.get('id')?.value))"><mat-icon >delete</mat-icon></button></td>
        </tr>
      }
    </table>
    <!-- Add attribute -->
    <!-- <div id="newattribute">
    <select [formControl]="newattribute"  placeholder="Ajouter un attribut" class="custom-select" (change)="onAddattribute()">
      <option value="" disabled selected>Ajouter un attribut</option>
      <option *ngFor="let p of attributes" [value]="p.id" [disabled]="isAttributeInTemplate(p)"  > {{ p.name }} </option>
    </select>
  </div> -->
</form>
}